export default "__VITE_ASSET__zB0OvGaD__"